var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.625,
    height: 26.333,
    viewBox: "0 0 32.625 26.333"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-comment_svg__cls-2{fill:none;stroke:#07479b;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-comment_svg__ICN_Comentarii_Enabled",
    transform: "translate(-1040.999 -721.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-comment_svg__Path_978",
    "data-name": "Path 978",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.529 25.434l-3.537-3.742H6.581A6.581 6.581 0 010 15.112V6.58A6.581 6.581 0 016.581 0h19.463a6.581 6.581 0 016.581 6.58v8.533a6.581 6.581 0 01-6.581 6.58h-6.872l-3.537 3.741a2.792 2.792 0 01-4.106 0z",
    transform: "translate(1040.999 721.993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.582 24.733c.331 0 .647-.142.89-.399l3.538-3.741.473-.5H26.043a4.986 4.986 0 004.982-4.98V6.58a4.986 4.986 0 00-4.981-4.98H6.58A4.986 4.986 0 001.6 6.58v8.532a4.986 4.986 0 004.981 4.98h2.101l.473.5 3.537 3.742c.243.257.56.399.89.399m0 1.6c-.743 0-1.486-.3-2.053-.9l-3.537-3.74h-1.41A6.58 6.58 0 010 15.112V6.58A6.58 6.58 0 016.581 0h19.463a6.58 6.58 0 016.58 6.58v8.532a6.58 6.58 0 01-6.58 6.58h-6.872l-3.537 3.742c-.567.6-1.31.899-2.053.899z",
    fill: "#07479b",
    transform: "translate(1040.999 721.993)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-comment_svg__Path_979",
    "data-name": "Path 979",
    className: "kpmg-comment_svg__cls-2",
    d: "M0 0h17.671",
    transform: "translate(1048.477 737.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-comment_svg__Path_980",
    "data-name": "Path 980",
    d: "M1048.477 732.839h17.671",
    stroke: "#009ceb",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-comment_svg__Path_981",
    "data-name": "Path 981",
    className: "kpmg-comment_svg__cls-2",
    d: "M0 0h9.555",
    transform: "translate(1048.477 727.833)"
  }))));
}

export default SvgKpmgComment;